var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component,{tag:"component",class:['load_layover', {
     'load_layover--bg_blurred': _vm.bluringCondition,
     'load_layover--bg': _vm.blockingCondition
}]},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }